// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#debug-tools {
  position: fixed;
  top: 1rem;
  right: 1rem;
  width: 25vw;
  max-width: calc(100vw - 2rem);
  min-height: 50vh;
  max-height: calc(100vh - 4rem);
  background: rgba(0, 0, 0, 0.75);
  border-radius: 0.5rem;
  color: #fff;
  margin: 0;
  padding: 0.75rem;
  box-shadow: -0.5rem 0.5rem 2rem rgba(0, 0, 0, 0.25);
  overflow: hidden auto;
  z-index: 1080;
}
#debug-tools a {
  color: #fff !important;
}
#debug-tools summary {
  cursor: pointer;
}
#debug-tools {
  /* ===== Scrollbar CSS ===== */
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #595959 #ffffff;
  /* Chrome, Edge, and Safari */
}
#debug-tools::-webkit-scrollbar {
  width: 8px;
}
#debug-tools::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0);
}
#debug-tools::-webkit-scrollbar-thumb {
  background-color: #595959;
  border-radius: 10px;
}

.Debug-Button {
  position: fixed;
  z-index: 1080;
}
.Debug-Button.top {
  border-radius: 0 0 50% 50% !important;
  top: -4px;
  left: 1rem;
}
.Debug-Button.end {
  border-radius: 50% 0 0 50% !important;
  top: 1rem;
  right: -4px;
}
.Debug-Button.bottom {
  border-radius: 50% 50% 0 0 !important;
  bottom: -4px;
  right: 1rem;
}
.Debug-Button.start {
  border-radius: 0 50% 50% 0 !important;
  top: 1rem;
  left: -4px;
}
.Debug-Button.full {
  border-radius: 0 50% 50% 0 !important;
  top: 1rem;
  left: -4px;
}

.offcanvas.offcanvas-full {
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/DebugTools/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,mDAAA;EACA,qBAAA;EACA,aAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAtBA;EAyBE,8BAAA;EACA,YAAA;EACA,qBAAA;EACA,gCAAA;EAEA,6BAAA;AADF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,kCAAA;AADJ;AAIE;EACE,yBAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,aAAA;AAHF;AAKE;EACE,qCAAA;EACA,SAAA;EACA,UAAA;AAHJ;AAME;EACE,qCAAA;EACA,SAAA;EACA,WAAA;AAJJ;AAOE;EACE,qCAAA;EACA,YAAA;EACA,WAAA;AALJ;AAQE;EACE,qCAAA;EACA,SAAA;EACA,UAAA;AANJ;AASE;EACE,qCAAA;EACA,SAAA;EACA,UAAA;AAPJ;;AAWA;EACE,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;AARF","sourcesContent":["#debug-tools {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  width: 25vw;\n  max-width: calc(100vw - 2rem);\n  min-height: 50vh;\n  max-height: calc(100vh - 4rem);\n  background: rgba(0, 0, 0, 0.75);\n  border-radius: 0.5rem;\n  color: #fff;\n  margin: 0;\n  padding: 0.75rem;\n  box-shadow: -0.5rem 0.5rem 2rem rgba(0, 0, 0, 0.25);\n  overflow: hidden auto;\n  z-index: 1080;\n\n  a {\n    color: #fff !important;\n  }\n\n  summary {\n    cursor: pointer;\n  }\n\n  /* ===== Scrollbar CSS ===== */\n  /* Firefox */\n  scrollbar-width: auto;\n  scrollbar-color: #595959 #ffffff;\n\n  /* Chrome, Edge, and Safari */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #595959;\n    border-radius: 10px;\n  }\n}\n\n.Debug-Button {\n  position: fixed;\n  z-index: 1080;\n\n  &.top {\n    border-radius: 0 0 50% 50% !important;\n    top: -4px;\n    left: 1rem;\n  }\n\n  &.end {\n    border-radius: 50% 0 0 50% !important;\n    top: 1rem;\n    right: -4px;\n  }\n\n  &.bottom {\n    border-radius: 50% 50% 0 0 !important;\n    bottom: -4px;\n    right: 1rem;\n  }\n\n  &.start {\n    border-radius: 0 50% 50% 0 !important;\n    top: 1rem;\n    left: -4px;\n  }\n\n  &.full {\n    border-radius: 0 50% 50% 0 !important;\n    top: 1rem;\n    left: -4px;\n  }\n}\n\n.offcanvas.offcanvas-full {\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  border: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
